const jerseyData = window.jerseyData || {};
const countryGroups = window.countryGroups || {};

const currentLocale = String(
  window.MaillotConfig?.locale || 'fr'
)
  .toLowerCase()
  .split('-')[0];

const nameKeyMap = {
  fr: 'nom_fr',
  en: 'nom_en',
  de: 'nom_de',
  es: 'nom_es',
  pt: 'nom_pt',
  it: 'nom_it',
  nl: 'nom_nl',
  sv: 'nom_sv',
  da: 'nom_da',
  no: 'nom_no',
  fi: 'nom_fi'
};

const nameKey = nameKeyMap[currentLocale] || 'nom_fr';

const selectA   = document.getElementById('paysA');
const selectB   = document.getElementById('paysB');
const toggleBtn = document.getElementById('toggleView');
const canvas    = document.getElementById('maillotCanvas');
const ctx       = canvas.getContext('2d');

let isBack = false;


// --- Flocage : champs optionnels (doivent exister dans ton HTML) ---
const hasFlocage    = document.getElementById('hasFlocage');   // checkbox ou select "yes"/"no"
const flocNameInput = document.getElementById('flocName');     // texte (max 12)
const flocNumInput  = document.getElementById('flocNum');      // number (1-99)
const flocName2Input = document.getElementById('flocName2');

function toggleFlocageFields() {
  const enabled = hasFlocage?.checked;

  if (flocNameInput) {
    flocNameInput.disabled = !enabled;
  }

  if (flocNumInput) {
    flocNumInput.disabled = !enabled;
  }

  if (flocName2Input) {
    flocName2Input.disabled = !enabled;
  }

  // Si on retire le flocage, on vide tout
  if (!enabled) {
    if (flocNameInput) flocNameInput.value = '';
    if (flocNumInput) flocNumInput.value = '';
    if (flocName2Input) flocName2Input.value = '';
  }
}

// Hidden pour Shopify line item properties (option payante)
const inputPaysA     = document.getElementById('input-paysA');
const inputPaysB     = document.getElementById('input-paysB');
const inputView      = document.getElementById('input-view');
const inputFlocage   = document.getElementById('input-flocage');    // "Oui"/"Non"
const inputFlocName  = document.getElementById('input-floc-name');  // NOM
const inputFlocNum   = document.getElementById('input-floc-num');   // 1..99
const inputFlocage2  = document.getElementById('input-flocage2');
const inputFlocName2 = document.getElementById('input-floc-name2');

function populateCountrySelectsOnce() {
  if (selectA.dataset.populated === '1') return;

  selectA.innerHTML = '';
  selectB.innerHTML = '';

  const sortedKeys = Object.keys(jerseyData)
  .sort((a, b) => (jerseyData[a][nameKey] || a).localeCompare((jerseyData[b][nameKey] || b), currentLocale));

  const addOption = (select, key, isChild = false) => {
    const nom = jerseyData[key][nameKey] || key; // <-- Utilise la bonne langue
    const option = new Option(
      isChild ? "  ↳ " + nom : nom,
      key
    );
    if (isChild) option.dataset.child = "1";
    select.add(option);
  };

  sortedKeys.forEach(key => {
    // si c'est un pays parent
    if (countryGroups[key]) {
      addOption(selectA, key);
      addOption(selectB, key);

      // ajouter ses régions juste après
      countryGroups[key].forEach(childKey => {
        if (jerseyData[childKey]) {
          addOption(selectA, childKey, true);
          addOption(selectB, childKey, true);
        }
      });
    }
    // sinon, ajouter normalement (seulement si pas déjà listé comme enfant)
    else if (!Object.values(countryGroups).flat().includes(key)) {
      addOption(selectA, key);
      addOption(selectB, key);
    }
  });

  selectA.dataset.populated = '1';
}

populateCountrySelectsOnce();

function normalizeSearch(str) {
  return (str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // enlève les accents
    .replace(/[’']/g, "")            // ignore apostrophes
    .replace(/[-\s]+/g, " ")         // normalise espaces/tirets
    .toLowerCase()
    .trim();
}

function attachAutocomplete(selectId) {
  const select = document.getElementById(selectId);

  const searchInput = document.createElement("input");
  searchInput.type = "text";
  if (currentLocale === 'nl') searchInput.placeholder = "Zoeken...";
  else if (currentLocale === 'sv') searchInput.placeholder = "Sök...";
  else if (currentLocale === 'da') searchInput.placeholder = "Søg...";
  else if (currentLocale === 'no') searchInput.placeholder = "Søk...";
  else if (currentLocale === 'fi') searchInput.placeholder = "Etsi...";
  else if (currentLocale === 'it') searchInput.placeholder = "Cerca...";
  else if (currentLocale === 'pt') searchInput.placeholder = "Pesquisar...";
  else if (currentLocale === 'es') searchInput.placeholder = "Buscar...";
  else if (currentLocale === 'de') searchInput.placeholder = "Suchen...";
  else if (currentLocale === 'en') searchInput.placeholder = "Search...";
  else searchInput.placeholder = "Rechercher";
  searchInput.classList.add("country-search");

  const resultsBox = document.createElement("div");
  resultsBox.classList.add("autocomplete-results");

  select.parentNode.insertBefore(searchInput, select);
  select.parentNode.appendChild(resultsBox);

  const allOptions = [...select.options];

  searchInput.addEventListener("input", () => {
    const filterRaw = searchInput.value;
    const filter = normalizeSearch(filterRaw);   // ← ici
    resultsBox.innerHTML = "";

    if (filter.length < 1) return;

    const matches = allOptions.filter(opt =>
      normalizeSearch(opt.text).includes(filter) ||
      normalizeSearch(opt.value).includes(filter)
    );

    matches.forEach(opt => {
      const item = document.createElement("div");
      item.textContent = opt.text;
      item.classList.add("autocomplete-item");
      item.addEventListener("click", () => {
        select.value = opt.value;
        select.dispatchEvent(new Event("change"));
        searchInput.value = opt.text;
        resultsBox.innerHTML = "";
      });
      resultsBox.appendChild(item);
    });
  });

  document.addEventListener("click", (e) => {
    if (!resultsBox.contains(e.target) && e.target !== searchInput) {
      resultsBox.innerHTML = "";
    }
  });
}

document.getElementById("swapCountries").addEventListener("click", () => {
  const temp = selectA.value;
  selectA.value = selectB.value;
  selectB.value = temp;
  syncProperties();
  updateCanvas();
});
// Active sur tes 2 menus
attachAutocomplete("paysA");
attachAutocomplete("paysB");

// Sélection par défaut
selectA.value = "france";
selectB.value = "senegal";

// Première synchro des propriétés (si tu les utilises)
if (typeof syncProperties === "function") syncProperties();

// >>> 1) INIT SÉCURISÉE : précharge 4 images, puis dessine
async function preloadCurrentSet() {
  const a = selectA.value, b = selectB.value;
  const view = isBack ? 'back' : 'front';
  const tasks = [
    getCachedImage(a + '_' + view, jerseyData[a][view], false),
    getCachedImage(b + '_' + view, jerseyData[b][view], false),
    getCachedImage(a + '_flag',   jerseyData[a].flag,  false),
    getCachedImage(b + '_flag',   jerseyData[b].flag,  false),
  ];
  // On tolère des ratés transitoires
  const res = await Promise.allSettled(tasks);
  const ok = res.every(r => r.status === 'fulfilled');
  return ok;
}
async function ensureRedigLoaded() {
  try {
    // Déclencheur de chargement : on demande explicitement la police
    await document.fonts.load('400 200px "Redig-Regular"');
    // (facultatif) si tu veux de l'apparence "bold", charge une vraie fonte bold,
    // sinon laisse 400 : Safari simule le gras et peut retomber en fallback.
    // await document.fonts.load('700 200px "Redig-Bold"');
  } catch(e) {}
}

// Appelle ceci AVANT le premier rendu
(async () => {
  await ensureRedigLoaded();
  await initFirstPaint();          // tu l’as déjà
  // Sécurise aussi les rerendus quand les fonts finissent d'arriver
  document.fonts?.ready?.then(() => updateCanvas());
})();

async function initFirstPaint(retryCount = 0) {
  const ok = await preloadCurrentSet();
  try {
    if (!ok) throw new Error('preload failed');
    await updateCanvas();
  } catch (e) {
    // Petit retry exponentiel en cas de hoquet réseau/CORS initial
    if (retryCount < 3) {
      const backoff = 200 * Math.pow(2, retryCount); // 200, 400, 800 ms
      setTimeout(() => initFirstPaint(retryCount + 1), backoff);
      return;
    }
    // Dernier recours : on tente quand même un rendu
    try { await updateCanvas(); } catch {}
  }
}

// Lance l'init protégée
initFirstPaint();

// >>> 2) PRÉCHAUFFAGE léger, seulement la sélection courante
async function warmSelected() {
  const a = selectA.value, b = selectB.value;
  const view = isBack ? 'back' : 'front';
  getCachedImage(a + '_' + view, jerseyData[a][view], false);
  getCachedImage(b + '_' + view, jerseyData[b][view], false);
  getCachedImage(a + '_flag',   jerseyData[a].flag,   false);
  getCachedImage(b + '_flag',   jerseyData[b].flag,   false);
}


// Et sur changement A/B on “réchauffe” juste ce qu’il faut :
selectA.addEventListener("change", () => { syncProperties(); updateCanvas().then(warmSelected); });
selectB.addEventListener("change", () => { syncProperties(); updateCanvas().then(warmSelected); });

// Optionnel : un petit warm-up différé de quelques candidats
window.requestIdleCallback?.(() => {
  // ex: précharger 4-6 pays probables… (laisser vide si inutile)
});



// --- Helpers masques & images ---
function createPathFromPoints(points, invert = false, canvasWidth = 800, canvasHeight = 800) {
  const path = new Path2D();
  if (!invert) {
    path.moveTo(points[0][0], 0);
    for (const [x, y] of points) path.lineTo(x, y);
    path.lineTo(canvasWidth, canvasHeight);
    path.lineTo(canvasWidth, 0);
    path.closePath();
  } else {
    path.moveTo(0, 0);
    path.lineTo(points[0][0], 0);
    for (const [x, y] of points) path.lineTo(x, y);
    path.lineTo(0, canvasHeight);
    path.closePath();
  }
  return path;
}

function loadImage(url, flip = false) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.referrerPolicy = "no-referrer";
    img.onload = () => {
      if (!flip) return resolve(img);
      const off = document.createElement("canvas");
      off.width = img.width; off.height = img.height;
      const octx = off.getContext("2d");
      octx.translate(img.width, 0);
      octx.scale(-1, 1);
      octx.drawImage(img, 0, 0);
      const flipped = new Image();
      flipped.onload = () => resolve(flipped);
      flipped.src = off.toDataURL("image/png");
    };
    img.onerror = reject;
    img.src = url;
  });
}

const imageCache = {};
async function getCachedImage(key, url, flip = false) {
  const cacheKey = key + (flip ? "_flipped" : "_normal");
  if (imageCache[cacheKey]) return imageCache[cacheKey];
  const img = await loadImage(url, flip);
  imageCache[cacheKey] = img;
  return img;
}

// --- Utils flocage ---
function clampNum(v) {
  if (v === '' || v == null) return '';

  let s = String(v).replace(/\D/g, '').slice(0, 3);

  if (s === '') return '';

  const n = parseInt(s, 10);
  if (n > 999) return '999';

  return s;
}

// taille de police pour le NOM qui diminue légèrement après 9 caractères
function getNameFontSize(len, basePx = 210) {
  if (len <= 9) return basePx;
  const extra = len - 9;
  const step = 8; // réduction douce par caractère
  return Math.max(140, basePx - extra * step);
}

// sanitize + format inputs flocage
function normalizeFlocInputs({ commit = false } = {}) {
  if (flocNameInput) {
    const up = (flocNameInput.value || '')
      .toLocaleUpperCase()
      .replace(/[^\p{L}0-9 \-']/gu, '')
      .slice(0, 12);

    flocNameInput.value = up;
  }

  if (flocName2Input) {
    flocName2Input.value = (flocName2Input.value || '')
      .toLocaleUpperCase()
      .replace(/[^\p{L}0-9 \-']/gu, '')
      .slice(0, 10);
  }

  if (commit && flocNumInput) {
    flocNumInput.value = clampNum(flocNumInput.value);
  }
}


// --- Dessin du flocage (dos uniquement) ---
async function drawFlocageOnBack() {
  // actif si checkbox cochée ou select "yes"
  const enabled =
    (hasFlocage && hasFlocage.type === 'checkbox' && hasFlocage.checked) ||
    (hasFlocage && hasFlocage.tagName === 'SELECT' && hasFlocage.value === 'yes');

  if (!enabled) return;

  normalizeFlocInputs();

  // (Optionnel) s’assurer que les polices custom sont prêtes
  if (document.fonts && document.fonts.ready) {
    try { await document.fonts.ready; } catch(e){}
  }

  const name = (flocNameInput?.value || '').toLocaleUpperCase();
  const num  = String(clampNum(flocNumInput?.value));

  const w = canvas.width, h = canvas.height;
  const cx = w * 0.50;
  const nameY = h * 0.15; // plus haut
  const numY  = h * 0.40; // plus haut

  // styles
  const family = '"Redig-Regular", sans-serif';
  const nameSize = getNameFontSize(name.length, 330);
  const numSize  = 1140;

  const nameStroke = 12; // bordure plus fine
  const numStroke  = 12; // bordure plus fine²

  ctx.save();
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineJoin = 'round';

  // NOM
  if (name) {
    ctx.font = `${nameSize}px ${family}`;
    ctx.lineWidth = nameStroke;
    ctx.strokeStyle = 'rgba(0,0,0,0.85)';
    ctx.fillStyle = '#ffffff';
    ctx.strokeText(name, cx, nameY);
    ctx.fillText(name, cx, nameY);
  }

  // NUMÉRO
  ctx.font = `${numSize}px ${family}`;
  ctx.lineWidth = numStroke;
  ctx.strokeStyle = 'rgba(0,0,0,0.9)';
  ctx.fillStyle = '#ffffff';
  const spacing = 50; // px à ajuster selon ton goût
const chars = num.split('');
const totalWidth = chars.reduce((acc, ch) => acc + ctx.measureText(ch).width, 0) + spacing * (chars.length - 1);

// point de départ pour centrer
let startX = cx - totalWidth / 2;

for (const ch of chars) {
  ctx.strokeText(ch, startX + ctx.measureText(ch).width / 2, numY);
  ctx.fillText(ch, startX + ctx.measureText(ch).width / 2, numY);
  startX += ctx.measureText(ch).width + spacing;
}
// ======================================================
// DEUXIÈME NOM - POSITION PROVISOIRE EN BAS DU MAILLOT
// ======================================================

const name2 = (flocName2Input?.value || '').toLocaleUpperCase();

if (name2) {
  // Même écart que entre NOM 1 et le NUMÉRO
  const gapNameToNumber = numY - nameY;
  const secondNameY = numY + gapNameToNumber;

  // Exactement la même taille que NOM 1
  const secondNameSize = nameSize;

  ctx.font = `${secondNameSize}px ${family}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  ctx.lineWidth = 10;
  ctx.strokeStyle = 'rgba(0,0,0,0.85)';
  ctx.fillStyle = '#ffffff';

  ctx.strokeText(name2, cx, secondNameY);
  ctx.fillText(name2, cx, secondNameY);
}

  ctx.restore();
}

// --- Rendu principal ---
async function updateCanvas() {
  const keyA = isBack ? selectB.value : selectA.value;
  const keyB = isBack ? selectA.value : selectB.value;

  const imgA  = await getCachedImage(keyA + (isBack ? '_back' : '_front'), jerseyData[keyA][isBack ? 'back' : 'front'], false);
  const imgB  = await getCachedImage(keyB + (isBack ? '_back' : '_front'), jerseyData[keyB][isBack ? 'back' : 'front'], false);
  const flagA = await getCachedImage(keyA + '_flag', jerseyData[keyA].flag);
  const flagB = await getCachedImage(keyB + '_flag', jerseyData[keyB].flag);

  ctx.imageSmoothingEnabled = false;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const points = [
    [1500,0],[1579,0],[1507,265],[1511,369],[1522,432],[1516,472],[1485,380],[1485,400],
    [1506,486],[1507,508],[1504,506],[1503,536],[1500,544],[1495,544],[1491,536],[1479,558],
    [1471,558],[1473,601],[1451,520],[1474,641],[1455,609],[1443,607],[1434,575],[1423,554],
    [1419,567],[1440,661],[1427,655],[1417,633],[1427,673],[1424,681],[1428,699],[1427,705],
    [1423,703],[1416,675],[1409,703],[1434,796],[1427,798],[1432,826],[1428,850],[1435,868],
    [1453,884],[1462,888],[1463,904],[1459,916],[1452,918],[1456,932],[1457,967],[1468,987],
    [1462,1005],[1451,1019],[1450,1033],[1447,1049],[1442,1051],[1432,1067],[1436,1083],[1437,1091],
    [1433,1095],[1433,1103],[1445,1128],[1450,1126],[1458,1136],[1456,1150],[1475,1198],[1487,1210],
    [1490,1212],[1490,1224],[1503,1228],[1508,1232],[1520,1290],[1498,1252],[1542,1407],[1558,1512],
    [1565,1534],[1569,1572],[1574,1580],[1589,1624],[1577,1624],[1526,1465],[1527,1508],[1535,1518],
    [1569,1642],[1569,1711],[1559,1711],[1554,1705],[1550,1719],[1534,1721],[1526,1709],[1541,1751],
    [1544,1793],[1535,1771],[1520,1769],[1502,1733],[1498,1711],[1495,1725],[1485,1721],[1520,1912],
    [1497,1900],[1505,1956],[1518,1974],[1522,1998],[1523,2028],[1529,2040],[1531,2065],[1537,2103],
    [1539,2135],[1541,2159],[1536,2177],[1532,2177],[1522,2193],[1524,2203],[1525,2215],[1507,2250],
    [1507,2260],[1512,2276],[1518,2280],[1530,2302],[1538,2352],[1555,2378],[1546,2392],[1561,2394],
    [1570,2443],[1555,2410],[1588,2585],[1574,2547],[1587,2634],[1576,2617],[1555,2569],[1574,2644],
    [1559,2607],[1534,2780],[1575,2939],[1500,3000]
  ];

  const pathRight = createPathFromPoints(points, false, canvas.width, canvas.height);
  const pathLeft  = createPathFromPoints(points,  true, canvas.width, canvas.height);

  // Partie gauche
  ctx.save();
  ctx.clip(pathLeft);
  ctx.drawImage(imgA, 0, 0, imgA.width, imgA.height, 0, 0, canvas.width, canvas.height);
  ctx.restore();

  // Partie droite
  ctx.save();
  ctx.clip(pathRight);
  ctx.drawImage(imgB, 0, 0, imgB.width, imgB.height, 0, 0, canvas.width, canvas.height);
  ctx.restore();

  // Face : demi-drapeaux sur poitrine
  if (!isBack) {
    const logoSize = 240;
    const logoY = canvas.height * 0.22 - 40;
    const logoX = canvas.width * 0.60;

    const createHalfLogo = (flag, isRight) => {
      const off = document.createElement('canvas');
      off.width = flag.width / 2;
      off.height = flag.height;
      const lctx = off.getContext('2d');
      lctx.imageSmoothingEnabled = false;
      const sx = isRight ? flag.width / 2 : 0;
      lctx.drawImage(flag, sx, 0, flag.width / 2, flag.height, 0, 0, flag.width / 2, flag.height);
      return off;
    };

    const halfLogoA = createHalfLogo(flagA, false);
    const halfLogoB = createHalfLogo(flagB, true);

    ctx.drawImage(halfLogoA, logoX, logoY, logoSize / 2, logoSize);
    ctx.drawImage(halfLogoB, logoX + logoSize / 2, logoY, logoSize / 2, logoSize);
  } else {
    // Dos : flocage si activé
    await drawFlocageOnBack();
  }
}

// --- Sync des propriétés cachées (Shopify) ---
function syncProperties() {
  // ===============================
  // PAYS + VUE
  // ===============================

  if (inputPaysA) {
    inputPaysA.value = selectA.value;
  }

  if (inputPaysB) {
    inputPaysB.value = selectB.value;
  }

  if (inputView) {
    inputView.value = isBack ? "dos" : "face";
  }


  // ===============================
  // FLOCAGE PRINCIPAL
  // ===============================

  const enabled =
    (hasFlocage &&
      hasFlocage.type === 'checkbox' &&
      hasFlocage.checked) ||
    (hasFlocage &&
      hasFlocage.tagName === 'SELECT' &&
      hasFlocage.value === 'yes');


  if (inputFlocage) {
    inputFlocage.value = enabled ? "Oui" : "Non";
  }


  // ===============================
  // NOM + NUMÉRO + NOM 2
  // ===============================

  if (enabled) {
    // Nettoyage / normalisation des champs
    normalizeFlocInputs();

    // Nom principal
    if (inputFlocName) {
      inputFlocName.value =
        (flocNameInput?.value || '').trim();
    }

    // Numéro
    if (inputFlocNum) {
      inputFlocNum.value =
        clampNum(flocNumInput?.value);
    }

    // Deuxième nom facultatif
    const secondName =
      (flocName2Input?.value || '').trim();

    if (inputFlocName2) {
      inputFlocName2.value = secondName;
    }

    // "Oui" uniquement si un deuxième nom est réellement renseigné
    if (inputFlocage2) {
      inputFlocage2.value =
        secondName ? "Oui" : "Non";
    }

  } else {

    // Si le flocage principal n'est pas activé,
    // on vide toutes les propriétés de flocage

    if (inputFlocName) {
      inputFlocName.value = '';
    }

    if (inputFlocNum) {
      inputFlocNum.value = '';
    }

    if (inputFlocName2) {
      inputFlocName2.value = '';
    }

    if (inputFlocage2) {
      inputFlocage2.value = "Non";
    }
  }


  // ===============================
  // MINI PREVIEW SHOPIFY
  // ===============================

  const previewInput =
    document.getElementById('input-preview');

  if (previewInput && canvas) {
    try {
      previewInput.value =
        generateMiniPreview(200);
    } catch (e) {
      console.warn(
        "Impossible de générer la mini-preview du maillot",
        e
      );
    }
  }


  // ===============================
  // MASQUE FLOCAGE
  // ===============================

  const flocMaskInput =
    document.getElementById('input-flocmask');

  if (flocMaskInput) {
    if (enabled) {
      try {
        flocMaskInput.value =
          generateFlocageMask();
      } catch (e) {
        console.warn(
          "Impossible de générer le masque de flocage",
          e
        );

        flocMaskInput.value = "";
      }
    } else {
      flocMaskInput.value = "";
    }
  }
}

// --- Événements pays / vue ---
selectA.addEventListener("change", () => { syncProperties(); updateCanvas(); });
selectB.addEventListener("change", () => { syncProperties(); updateCanvas(); });

toggleBtn.addEventListener("click", () => {
  isBack = !isBack;
  if (currentLocale === 'nl') {
    toggleBtn.textContent = isBack ? "Bekijk voorkant" : "Bekijk achterkant";
  } else if (currentLocale === 'sv') {
    toggleBtn.textContent = isBack ? "Visa framsida" : "Visa baksida";
  } else if (currentLocale === 'da') {
    toggleBtn.textContent = isBack ? "Se forside" : "Se bagside";
  } else if (currentLocale === 'no') {
    toggleBtn.textContent = isBack ? "Se fremside" : "Se bakside";
  } else if (currentLocale === 'fi') {
    toggleBtn.textContent = isBack ? "Näytä etupuoli" : "Näytä takapuoli";
  } else if (currentLocale === 'it') {
    toggleBtn.textContent = isBack ? "Vedi fronte" : "Vedi retro";
  } else if (currentLocale === 'pt') {
    toggleBtn.textContent = isBack ? "Ver frente" : "Ver costas";
  } else if (currentLocale === 'es') {
    toggleBtn.textContent = isBack ? "Ver frente" : "Ver espalda";
  } else if (currentLocale === 'de') {
    toggleBtn.textContent = isBack ? "Vorderseite anzeigen" : "Rückseite anzeigen";
  } else if (currentLocale === 'en') {
    toggleBtn.textContent = isBack ? "See front" : "See back";
  } else {
    toggleBtn.textContent = isBack ? "Voir face" : "Voir dos";
  }
  syncProperties();
  updateCanvas();
});

// --- Événements flocage ---
function onFlocageChange() {
  toggleFlocageFields();
  normalizeFlocInputs();
  syncProperties();
  if (isBack) updateCanvas(); // live preview uniquement sur le dos
}

hasFlocage?.addEventListener('change', onFlocageChange);
flocNameInput?.addEventListener('input', onFlocageChange);
flocNumInput?.addEventListener('input', onFlocageChange);

flocName2Input?.addEventListener('input', onFlocageChange);

// Initialisation au chargement
toggleFlocageFields();
syncProperties();

  // Normalise un nom FR en slug lisible (sans accents, espaces -> tirets)
function frSlug(key) {
  const raw = (jerseyData[key]?.nom_fr || key);
  return raw
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // enlève accents
    .replace(/[^a-zA-Z0-9]+/g, '-')                   // espaces/punct -> -
    .replace(/^-+|-+$/g, '')                          // trim -
    .toLowerCase();
}

// Promisifie canvas.toBlob
function canvasToBlob(canvas) {
  return new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
}

// Rend et exporte une vue spécifique ('face' | 'dos') en PNG
async function exportViewPNG(view) {
  const prevIsBack   = isBack;
  const prevBtnLabel = toggleBtn?.textContent;

  // Bascule sur la vue demandée puis dessine
  isBack = (view === 'dos');
  if (toggleBtn) toggleBtn.textContent = isBack ? 'Voir face' : 'Voir dos';
  await updateCanvas();

  // Construit le nom de fichier avec noms FR des pays
  const a = frSlug(selectA.value);
  const b = frSlug(selectB.value);
  const filename = `maillot_${view}_${a}_${b}.png`;

  // Exporte
  const blob = await canvasToBlob(canvas);
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);

  // Restaure l'état précédent + rerendu
  isBack = prevIsBack;
  if (toggleBtn) toggleBtn.textContent = prevBtnLabel || (isBack ? 'Voir face' : 'Voir dos');
  await updateCanvas();
}

// Listeners des boutons
document.getElementById('exportFace')?.addEventListener('click', () => exportViewPNG('face'));
document.getElementById('exportDos') ?.addEventListener('click', () => exportViewPNG('dos'));
// --- Avant envoi du formulaire, synchro finale des données ---
// Mapping Taille -> ID de variante Shopify
const variantMap = {
  "4a":  "52422882492743",
  "5a":  "52422882525511",
  "6a":  "52422882558279",
  "7a":  "52422882591047",
  "8a":  "52422882623815",
  "10a": "52422882656583",
  "12a": "54006805922119",
  "14a": "54006805954887",
  "XS":  "52422882296135",
  "S":   "52422882328903",
  "M":   "52422882361671",
  "L":   "52422882394439",
  "XL":  "52422882427207",
  "2XL": "52422882459975",
  "3XL" : "54365977411911"
};

function generateMiniPreview(maxSize = 200) {
  if (!canvas) return "";

  const off = document.createElement("canvas");
  const ctx2 = off.getContext("2d");

  // Ratio pour réduire
  const ratio = Math.min(maxSize / canvas.width, maxSize / canvas.height);
  off.width = canvas.width * ratio;
  off.height = canvas.height * ratio;

  // Dessine l’image réduite
  ctx2.drawImage(canvas, 0, 0, off.width, off.height);

  // Retourne un dataURL réduit (base64)
  return off.toDataURL("image/png");
}
// --- Soumission du formulaire centralisée, nettoyée et sécurisée ---
document.getElementById('product-form').addEventListener('submit', async (e) => {
  e.preventDefault(); // Bloque la soumission native
  
  // 1. Force la synchronisation des propriétés cachées
  syncProperties();

  const size = document.getElementById('size').value;
  const quantity = parseInt(document.getElementById('quantity').value, 10) || 1;
  
  // Vérification de la variante du maillot
  if (!variantMap[size]) {
    let errorMsg = "Erreur : taille non reconnue !";
    if (currentLocale === 'nl') errorMsg = "Fout: Maat niet herkend!";
    else if (currentLocale === 'sv') errorMsg = "Fel: Storleken kändes inte igen!";
    else if (currentLocale === 'da') errorMsg = "Fejl: Størrelse ikke genkendt!";
    else if (currentLocale === 'no') errorMsg = "Feil: Størrelse ikke gjenkjent!";
    else if (currentLocale === 'fi') errorMsg = "Virhe: Kokoa ei tunnistettu!";
    else if (currentLocale === 'it') errorMsg = "Errore: Taglia non riconosciuta!";
    else if (currentLocale === 'pt') errorMsg = "Erro: Tamanho não reconhecido!";
    else if (currentLocale === 'es') errorMsg = "¡Error: Talla no reconocida!";
    else if (currentLocale === 'de') errorMsg = "Fehler: Größe nicht erkannt!";
    else if (currentLocale === 'en') errorMsg = "Error: Size not recognized!";
    alert(errorMsg);
    return;
  }

  // 2. Construction dynamique des propriétés (on ignore les clés vides pour Shopify)
  const maillotProperties = {};
  
  const addPropIfValid = (key, elementId) => {
    const val = document.getElementById(elementId)?.value;
    if (val && val.trim() !== "") {
      maillotProperties[key] = val.trim();
    }
  };

  // Assignation des propriétés
  addPropIfValid("Pays A", 'input-paysA');
  addPropIfValid("Pays B", 'input-paysB');
  addPropIfValid("Vue", 'input-view');
  addPropIfValid("Flocage", 'input-flocage');
  addPropIfValid("Nom", 'input-floc-name');
  addPropIfValid("Numéro", 'input-floc-num');
  addPropIfValid("Deuxième nom", 'input-flocage2');
  addPropIfValid("Nom 2", 'input-floc-name2');
  addPropIfValid("_Preview", 'input-preview');
  addPropIfValid("_FlocageMask", 'input-flocmask');

  // 3. Préparation du tableau des produits
  const itemsToAdd = [];

  // Ajout du maillot principal
  itemsToAdd.push({
    id: parseInt(variantMap[size], 10),
    quantity: quantity,
    properties: maillotProperties
  });

  // Si la case flocage est cochée, on ajoute le produit service Flocage
  const isFlocageChecked = document.getElementById('hasFlocage').checked;
  if (isFlocageChecked) {
    
    // Utilisation de l'ID de variante extrait du JSON sous forme de NOMBRE pur
    const vrayIdFlocage = 52422922436935; 

    const flocItem = {
      id: vrayIdFlocage,
      quantity: quantity
    };

    // On passe aussi les informations au produit flocage si elles existent
    const flocProps = {};

    if (maillotProperties["Nom"]) {
      flocProps["Nom"] = maillotProperties["Nom"];
    }

    if (maillotProperties["Numéro"]) {
      flocProps["Numéro"] = maillotProperties["Numéro"];
    }

    if (maillotProperties["Nom 2"]) {
      flocProps["Nom 2"] = maillotProperties["Nom 2"];
    }
    
    if (Object.keys(flocProps).length > 0) {
      flocItem.properties = flocProps;
    }

    itemsToAdd.push(flocItem);
  }

  // 4. Envoi groupé à Shopify en une seule transaction
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });

    const responseData = await response.json();

    if (response.ok) {
      // Succès : redirection vers le panier
      window.location.href = '/cart';
    } else {
      // Échec : affichage détaillé de l'erreur renvoyée par Shopify
      console.error("Détails du refus Shopify :", responseData);
      alert(`Erreur Shopify : ${responseData.description || responseData.message || "Impossible d'ajouter les options au panier."}`);
    }
  } catch (error) {
    console.error("Erreur réseau / JS :", error);
    alert("Une erreur technique est survenue.");
  }
});

function generateFlocageMask(maxSize = 400) {
  if (!canvas) return "";

  const off = document.createElement("canvas");
  const ctx = off.getContext("2d");

  off.width = canvas.width;
  off.height = canvas.height;

  ctx.font = "bold 80px Arial";
  ctx.fillStyle = "#000"; 
  if (flocNameInput?.value) {
    ctx.fillText(flocNameInput.value, 100, 100);
  }
  if (flocNumInput?.value) {
    ctx.fillText(flocNumInput.value, 100, 200);
  }

  const ratio = Math.min(maxSize / off.width, maxSize / off.height);
  const previewCanvas = document.createElement("canvas");
  const ctx2 = previewCanvas.getContext("2d");
  previewCanvas.width = off.width * ratio;
  previewCanvas.height = off.height * ratio;
  ctx2.drawImage(off, 0, 0, previewCanvas.width, previewCanvas.height);

  return previewCanvas.toDataURL("image/png");
}